(function() {
  'use strict';

  // ── Asset URLs (injected by Shopify Liquid, fallback for dev) ──────────────
  var LOGO_URL = (window.__QUIZ_ASSETS__ && window.__QUIZ_ASSETS__.logo) || '/hayat-logo.png';
  var PARASITE_URL = (window.__QUIZ_ASSETS__ && window.__QUIZ_ASSETS__.parasite) || '/parasite-image.jpg';
  var PRODUCT_URL = 'https://www.hayat.de/products/parasitenkur-im-islam-videokurs-produkt-bundle?variant=52585875439955';
  var MAX_POINTS = 31;

  // ── Quiz Data ──────────────────────────────────────────────────────────────
  var questions = [
    { id:1, category:'digestion', categoryLabel:'Verdauung', question:'Wie oft hast du Verdauungsbeschwerden? (Blähungen, Durchfall, Verstopfung)', answers:[{label:'Nie',points:0},{label:'Selten',points:1},{label:'Manchmal, 1-2x pro Woche',points:2},{label:'Häufig, 3-5x pro Woche',points:3},{label:'Fast täglich',points:4}] },
    { id:2, category:'bloating', categoryLabel:'Blähungen', question:'Hast du nach dem Essen ein aufgeblähtes Gefühl?', answers:[{label:'Nie',points:0},{label:'Selten',points:1},{label:'Regelmäßig',points:2},{label:'Fast immer',points:3}] },
    { id:3, category:'digestion', categoryLabel:'Verdauung', question:'Bemerkst du unverdaute Nahrungsreste im Stuhl?', answers:[{label:'Nie',points:0},{label:'Manchmal',points:1},{label:'Häufig',points:2}] },
    { id:4, category:'energy', categoryLabel:'Energie', question:'Wie würdest du dein Energielevel beschreiben?', answers:[{label:'Energiegeladen',points:0},{label:'Normal',points:1},{label:'Oft müde',points:2},{label:'Chronisch erschöpft',points:3}] },
    { id:5, category:'cravings', categoryLabel:'Heißhunger', question:'Hast du unerklärliche Heißhungerattacken, besonders auf Süßes?', answers:[{label:'Nie',points:0},{label:'Selten',points:1},{label:'Regelmäßig',points:2},{label:'Sehr oft',points:3}] },
    { id:6, category:'sleep', categoryLabel:'Schlaf', question:'Wie gut schläfst du?', answers:[{label:'Sehr gut',points:0},{label:'Meistens gut',points:1},{label:'Unruhig, wache oft auf',points:2},{label:'Sehr schlecht, Zähneknirschen',points:3}] },
    { id:7, category:'skin', categoryLabel:'Haut', question:'Hast du Hautprobleme? (Ausschläge, Juckreiz, Ekzeme)', answers:[{label:'Keine',points:0},{label:'Leichte',points:1},{label:'Mittlere',points:2},{label:'Starke',points:3}] },
    { id:8, category:'appearance', categoryLabel:'Aussehen', question:'Hast du dunkle Augenringe oder eine fahle Haut?', answers:[{label:'Nein',points:0},{label:'Leicht',points:1},{label:'Deutlich sichtbar',points:2}] },
    { id:9, category:'travel', categoryLabel:'Reisen', question:'Warst du in den letzten 12 Monaten im Ausland?', answers:[{label:'Nein',points:0},{label:'Ja, in Europa',points:1},{label:'Ja, außerhalb Europas',points:2}] },
    { id:10, category:'pets', categoryLabel:'Haustiere', question:'Hast du Haustiere?', answers:[{label:'Nein',points:0},{label:'Ja',points:1}] },
    { id:11, category:'diet', categoryLabel:'Ernährung', question:'Nimmst du regelmäßig rohes oder halbgares Fleisch/Fisch zu dir?', answers:[{label:'Nie',points:0},{label:'Selten',points:1},{label:'Regelmäßig',points:2}] },
    { id:12, category:'history', categoryLabel:'Vorgeschichte', question:'Hast du schon einmal eine Darmreinigung oder Parasitenkur gemacht?', answers:[{label:'Ja, regelmäßig',points:0},{label:'Ja, einmal',points:1},{label:'Nein, noch nie',points:2}] }
  ];

  var CATEGORY_ICONS = {
    digestion:'🍽️', bloating:'💨', energy:'⚡', cravings:'🍬',
    sleep:'🌙', skin:'✋', appearance:'👁️', travel:'✈️',
    pets:'🐾', diet:'🥩', history:'📋'
  };

  // ── State ──────────────────────────────────────────────────────────────────
  var state = {
    page: 'start',
    currentQuestion: 0,
    answers: [],
    totalPoints: 0,
    topSymptoms: []
  };

  // ── Root element ───────────────────────────────────────────────────────────
  var root = document.getElementById('parasiten-quiz-root');
  if (!root) return;

  // ── Helpers ────────────────────────────────────────────────────────────────
  function getRiskLevel(totalPoints) {
    var pct = Math.round((totalPoints / MAX_POINTS) * 100);
    if (pct <= 20) return { label:'Geringes Risiko', percentage:pct, color:'#22C55E', description:'Dein Testergebnis zeigt keine auffälligen Anzeichen einer Parasitenbelastung.', analysisText:'Dein Körper scheint im Gleichgewicht zu sein. Dennoch kann eine präventive Reinigung nach Tibb an-Nabawi sinnvoll sein, um deine Gesundheit langfristig zu erhalten.' };
    if (pct <= 40) return { label:'Leichtes Risiko', percentage:pct, color:'#EAB308', description:'Dein Testergebnis zeigt einige Anzeichen, die auf eine mögliche Dysbalance hindeuten.', analysisText:'Einige deiner Antworten deuten auf eine mögliche Belastung hin. Eine Parasitenkur nach Tibb an-Nabawi könnte dir helfen, deinen Körper zu reinigen und mehr Energie zu gewinnen.' };
    if (pct <= 65) return { label:'Mittleres Risiko', percentage:pct, color:'#F97316', description:'Dein Testergebnis deutet auf mehrere Symptome hin, die typisch für eine Parasitenbelastung sind.', analysisText:'Mehrere typische Symptome sind bei dir vorhanden. Eine Parasitenkur nach Tibb an-Nabawi wird empfohlen, um deinen Darm zu reinigen und dein Immunsystem zu stärken.' };
    return { label:'Erhöhtes Risiko', percentage:pct, color:'#DC2626', description:'Dein Testergebnis deutet auf eine signifikante Dysbalance hin, die typisch für eine Parasitenbelastung ist.', analysisText:'Deine Symptome deuten stark auf eine mögliche Parasitenbelastung hin. Eine Kur nach Tibb an-Nabawi ist dringend empfohlen, um dein inneres Gleichgewicht wiederherzustellen und dein Immunsystem nachhaltig zu stärken.' };
  }

  function calculateTopSymptoms(answers) {
    var scores = {};
    answers.forEach(function(ans) {
      var q = questions.find(function(q) { return q.id === ans.questionId; });
      if (q && ans.points > 0) {
        if (!scores[q.category]) scores[q.category] = { label: q.categoryLabel, points: 0 };
        scores[q.category].points += ans.points;
      }
    });
    return Object.entries(scores)
      .sort(function(a,b) { return b[1].points - a[1].points; })
      .map(function(entry) { return { category: entry[0], label: entry[1].label, points: entry[1].points }; });
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function highlightTibb(text) {
    return escapeHtml(text).replace(/Tibb an-Nabawi/g, '<strong style="color:#111816">Tibb an-Nabawi</strong>');
  }

  // ── Transition ─────────────────────────────────────────────────────────────
  function transitionTo(renderFn) {
    var current = root.querySelector('.pq-page');
    if (current) {
      current.classList.add('pq-exit');
      setTimeout(function() {
        root.innerHTML = '';
        var next = renderFn();
        root.appendChild(next);
        setTimeout(function() { next.classList.add('pq-visible'); }, 20);
      }, 280);
    } else {
      root.innerHTML = '';
      var next = renderFn();
      root.appendChild(next);
      setTimeout(function() { next.classList.add('pq-visible'); }, 20);
    }
  }

  // ── Footer (shared) ────────────────────────────────────────────────────────
  function makeFooter() {
    var el = document.createElement('footer');
    el.className = 'pq-footer';
    el.innerHTML = '<p class="pq-disclaimer">Disclaimer: Dieser Test dient ausschließlich Informationszwecken und ersetzt keine ärztliche Diagnose oder Behandlung.</p><p class="pq-copyright">© 2026 Hayat</p>';
    return el;
  }

  function makeLogoHeader(clickable) {
    var header = document.createElement('header');
    header.className = 'pq-header';
    if (clickable) {
      header.innerHTML = '<button class="pq-logo-btn" aria-label="Zum Anfang"><img class="pq-logo" src="' + escapeHtml(LOGO_URL) + '" alt="Hayat"></button>';
      header.querySelector('button').addEventListener('click', handleReset);
    } else {
      header.innerHTML = '<img class="pq-logo" src="' + escapeHtml(LOGO_URL) + '" alt="Hayat">';
    }
    return header;
  }

  // ── Pages ──────────────────────────────────────────────────────────────────

  function renderStart() {
    var page = document.createElement('div');
    page.className = 'pq-page';
    var container = document.createElement('main');
    container.className = 'pq-container';

    container.appendChild(makeLogoHeader(false));

    var card = document.createElement('div');
    card.className = 'pq-card';
    card.style.textAlign = 'center';
    card.innerHTML =
      '<h2 class="pq-headline">Leidest du unter Parasiten? Mach jetzt den Test</h2>' +
      '<p class="pq-subtext">Finde in 2 Minuten heraus, ob Parasiten deine Gesundheit beeinträchtigen könnten</p>' +
      '<p class="pq-badge">*Basierend auf Tibb an-Nabawi (Prophetenmedizin)*</p>' +
      '<div class="pq-mb-28 pq-flex-center">' +
        '<button class="pq-btn-primary" id="pq-start-btn" style="width:100%;max-width:280px">Jetzt Test starten</button>' +
      '</div>' +
      '<div class="pq-quiz-info">' +
        '<span>12 Fragen</span><span class="pq-quiz-info-dot"></span>' +
        '<span>2 Minuten</span><span class="pq-quiz-info-dot"></span>' +
        '<span>Kostenlos</span>' +
      '</div>';
    container.appendChild(card);
    container.appendChild(makeFooter());
    page.appendChild(container);

    page.querySelector('#pq-start-btn').addEventListener('click', function() {
      state.page = 'quiz';
      state.currentQuestion = 0;
      state.answers = [];
      state.totalPoints = 0;
      transitionTo(renderQuiz);
    });

    return page;
  }

  function renderQuiz() {
    var page = document.createElement('div');
    page.className = 'pq-page';
    var container = document.createElement('main');
    container.className = 'pq-container';

    container.appendChild(makeLogoHeader(true));

    // Progress bar
    var pct = ((state.currentQuestion + 1) / questions.length) * 100;
    var progress = document.createElement('div');
    progress.className = 'pq-progress-wrap';
    progress.innerHTML =
      '<div class="pq-progress-label"><span class="pq-text-sm pq-text-gray">Frage ' + (state.currentQuestion+1) + ' von ' + questions.length + '</span></div>' +
      '<div class="pq-progress-track"><div class="pq-progress-fill" style="width:' + pct + '%"></div></div>';
    container.appendChild(progress);

    // Question card
    var q = questions[state.currentQuestion];
    var card = document.createElement('div');
    card.className = 'pq-card pq-question-slide';
    card.style.textAlign = 'center';

    var answersHtml = q.answers.map(function(ans, idx) {
      return '<button class="pq-answer-btn" data-idx="' + idx + '">' +
        '<span>' + escapeHtml(ans.label) + '</span>' +
        '<span class="pq-answer-dot"></span>' +
      '</button>';
    }).join('');

    card.innerHTML =
      '<h2 class="pq-question-text">' + escapeHtml(q.question) + '</h2>' +
      '<div class="pq-answers">' + answersHtml + '</div>' +
      (state.currentQuestion > 0 ? '<div style="margin-top:24px;display:flex;justify-content:center"><button class="pq-btn-secondary" id="pq-back-btn">Zurück</button></div>' : '');

    // Add event listeners
    card.querySelectorAll('.pq-answer-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        handleAnswer(parseInt(btn.dataset.idx));
      });
    });

    if (state.currentQuestion > 0) {
      card.querySelector('#pq-back-btn').addEventListener('click', handleBack);
    }

    container.appendChild(card);
    container.appendChild(makeFooter());
    page.appendChild(container);
    return page;
  }

  function renderLoading() {
    var page = document.createElement('div');
    page.className = 'pq-page';
    var container = document.createElement('main');
    container.className = 'pq-container';

    container.appendChild(makeLogoHeader(true));

    var card = document.createElement('div');
    card.className = 'pq-card';
    card.style.textAlign = 'center';
    card.innerHTML =
      '<div class="pq-dots"><div class="pq-dot"></div><div class="pq-dot"></div><div class="pq-dot"></div></div>' +
      '<h2 style="font-size:1.25rem;font-weight:700;margin-bottom:16px">Deine Antworten werden analysiert...</h2>' +
      '<p style="color:#666;font-size:0.875rem;line-height:1.6;margin-bottom:32px">Bitte haben Sie einen Moment Geduld, während wir Ihre Ergebnisse basierend auf Tibb an-Nabawi auswerten.</p>' +
      '<div class="pq-loading-progress">' +
        '<div class="pq-progress-track"><div class="pq-progress-fill" id="pq-load-fill" style="width:0%"></div></div>' +
        '<div class="pq-loading-progress-labels"><span style="color:#888;font-size:11px;font-weight:500">Fortschritt</span><span style="color:#888;font-size:11px;font-weight:500" id="pq-load-pct">0%</span></div>' +
      '</div>';

    container.appendChild(card);

    var quote = document.createElement('p');
    quote.className = 'pq-quote';
    quote.textContent = '"Geduld ist ein Schlüssel zur Heilung."';
    container.appendChild(quote);
    container.appendChild(makeFooter());
    page.appendChild(container);

    // Animate progress
    var fill = null;
    var pctEl = null;
    var prog = 0;
    var interval = setInterval(function() {
      prog = Math.min(prog + (100 / (4000 / 50)), 100);
      if (!fill) fill = document.getElementById('pq-load-fill');
      if (!pctEl) pctEl = document.getElementById('pq-load-pct');
      if (fill) fill.style.width = prog + '%';
      if (pctEl) pctEl.textContent = Math.round(prog) + '%';
    }, 50);

    setTimeout(function() {
      clearInterval(interval);
      state.page = 'result';
      transitionTo(renderResult);
    }, 4000);

    return page;
  }

  function renderResult() {
    var risk = getRiskLevel(state.totalPoints);
    var radius = 68;
    var circumference = 2 * Math.PI * radius;
    var offset = circumference - (risk.percentage / 100) * circumference;

    var page = document.createElement('div');
    page.className = 'pq-page';
    var container = document.createElement('main');
    container.className = 'pq-container-wide';

    // Header with margin-top
    var header = makeLogoHeader(true);
    header.style.marginTop = '20px';
    container.appendChild(header);

    // Circle + risk
    var circleWrap = document.createElement('section');
    circleWrap.className = 'pq-circle-wrap';
    circleWrap.innerHTML =
      '<div class="pq-circle-container">' +
        '<svg class="pq-circle-svg" viewBox="0 0 153 153">' +
          '<circle cx="76.5" cy="76.5" r="' + radius + '" fill="transparent" stroke="#e5e7eb" stroke-width="10"/>' +
          '<circle id="pq-risk-circle" cx="76.5" cy="76.5" r="' + radius + '" fill="transparent" stroke="' + escapeHtml(risk.color) + '" stroke-width="10" stroke-dasharray="' + circumference + '" stroke-dashoffset="' + circumference + '" stroke-linecap="round" style="transition:stroke-dashoffset 1.5s ease"/>' +
        '</svg>' +
        '<span class="pq-circle-label" style="color:' + escapeHtml(risk.color) + '">' + risk.percentage + '%</span>' +
      '</div>' +
      '<h1 class="pq-risk-label" style="color:' + escapeHtml(risk.color) + '">' + escapeHtml(risk.label) + '</h1>' +
      '<p class="pq-risk-desc">' + escapeHtml(risk.description) + '</p>';
    container.appendChild(circleWrap);

    // Animate circle after mount
    setTimeout(function() {
      var circle = document.getElementById('pq-risk-circle');
      if (circle) circle.setAttribute('stroke-dashoffset', offset);
    }, 100);

    // Analysis card
    var analysisCard = document.createElement('div');
    analysisCard.className = 'pq-card';
    analysisCard.style.marginBottom = '20px';

    var symptomsHtml = '';
    if (state.topSymptoms.length > 0) {
      var chips = state.topSymptoms.slice(0, 3).map(function(s) {
        return '<div class="pq-chip"><span>' + (CATEGORY_ICONS[s.category] || '•') + '</span><span>' + escapeHtml(s.label) + '</span></div>';
      }).join('');
      symptomsHtml = '<div><p class="pq-symptoms-title">Deine Symptome</p><div class="pq-symptom-chips">' + chips + '</div></div>';
    }

    analysisCard.innerHTML =
      '<div class="pq-analysis-inner">' +
        '<div class="pq-parasite-img" style="background-image:url(\'' + escapeHtml(PARASITE_URL) + '\')"></div>' +
        '<div class="pq-analysis-content">' +
          '<h3 class="pq-analysis-title">Deine Analyse</h3>' +
          '<p class="pq-analysis-text">' + highlightTibb(risk.analysisText) + '</p>' +
          symptomsHtml +
        '</div>' +
      '</div>' +
      '<div class="pq-result-btns">' +
        '<button class="pq-btn-outline" id="pq-retry-btn">Test wiederholen</button>' +
        '<a href="' + escapeHtml(PRODUCT_URL) + '" class="pq-btn-primary" style="flex:1;text-decoration:none" target="_blank" rel="noopener noreferrer">Jetzt Parasitenkur entdecken <span>→</span></a>' +
      '</div>';

    analysisCard.querySelector('#pq-retry-btn').addEventListener('click', handleReset);
    container.appendChild(analysisCard);

    // Disclaimer box
    var disc = document.createElement('div');
    disc.className = 'pq-disclaimer-box';
    disc.innerHTML =
      '<div class="pq-disclaimer-header">' +
        '<div class="pq-disclaimer-icon">i</div>' +
        '<h4 class="pq-disclaimer-title">Wichtiger Hinweis & Disclaimer</h4>' +
      '</div>' +
      '<p class="pq-disclaimer-text">Dieser Schnelltest dient der Orientierung und basiert auf den Prinzipien der Prophetischen Medizin (Tibb an-Nabawi). Er ersetzt keine ärztliche Diagnose oder Behandlung. Die Ergebnisse sind als Empfehlung zu verstehen, um das allgemeine Wohlbefinden zu steigern. Bei akuten oder anhaltenden Beschwerden konsultieren Sie bitte einen qualifizierten Arzt oder Heilpraktiker.</p>';
    container.appendChild(disc);

    // Divider + footer
    var hr = document.createElement('hr');
    hr.className = 'pq-divider';
    container.appendChild(hr);

    var footer = document.createElement('footer');
    footer.className = 'pq-result-footer';
    footer.innerHTML =
      '<p class="pq-footer-text">© 2026 Hayat - Ganzheitliche Gesundheit nach Tibb an-Nabawi</p>' +
      '<a href="https://www.hayat.de/pages/impressum" class="pq-footer-link" target="_blank" rel="noopener noreferrer">Impressum</a>';
    container.appendChild(footer);

    page.appendChild(container);
    return page;
  }

  // ── Handlers ───────────────────────────────────────────────────────────────

  function handleAnswer(answerIndex) {
    var q = questions[state.currentQuestion];
    var ans = q.answers[answerIndex];

    state.answers.push({ questionId: q.id, answerIndex: answerIndex, points: ans.points });
    state.totalPoints += ans.points;

    if (state.currentQuestion < questions.length - 1) {
      state.currentQuestion++;
      // Slide out current card, then render next
      var card = root.querySelector('.pq-question-slide');
      if (card) {
        card.classList.add('pq-slide-out');
        setTimeout(function() {
          // Update progress bar inline for speed
          var pct = ((state.currentQuestion + 1) / questions.length) * 100;
          var fill = root.querySelector('.pq-progress-fill');
          var label = root.querySelector('.pq-progress-label span');
          if (fill) fill.style.width = pct + '%';
          if (label) label.textContent = 'Frage ' + (state.currentQuestion+1) + ' von ' + questions.length;

          // Swap card content
          var newCard = document.createElement('div');
          newCard.className = 'pq-card pq-question-slide pq-slide-in';
          newCard.style.textAlign = 'center';
          var newQ = questions[state.currentQuestion];
          var answersHtml = newQ.answers.map(function(a, idx) {
            return '<button class="pq-answer-btn" data-idx="' + idx + '"><span>' + escapeHtml(a.label) + '</span><span class="pq-answer-dot"></span></button>';
          }).join('');
          newCard.innerHTML =
            '<h2 class="pq-question-text">' + escapeHtml(newQ.question) + '</h2>' +
            '<div class="pq-answers">' + answersHtml + '</div>' +
            (state.currentQuestion > 0 ? '<div style="margin-top:24px;display:flex;justify-content:center"><button class="pq-btn-secondary" id="pq-back-btn">Zurück</button></div>' : '');

          newCard.querySelectorAll('.pq-answer-btn').forEach(function(btn) {
            btn.addEventListener('click', function() { handleAnswer(parseInt(btn.dataset.idx)); });
          });
          if (state.currentQuestion > 0) {
            newCard.querySelector('#pq-back-btn').addEventListener('click', handleBack);
          }

          if (card.parentNode) card.parentNode.replaceChild(newCard, card);
          setTimeout(function() {
            newCard.classList.remove('pq-slide-in');
          }, 20);
        }, 230);
      }
    } else {
      // Last question answered
      state.topSymptoms = calculateTopSymptoms(state.answers);
      state.page = 'loading';
      transitionTo(renderLoading);
    }
  }

  function handleBack() {
    if (state.currentQuestion > 0) {
      var lastAns = state.answers.pop();
      state.totalPoints -= lastAns.points;
      state.currentQuestion--;
      // Re-render quiz page
      transitionTo(renderQuiz);
    }
  }

  function handleReset() {
    state.page = 'start';
    state.currentQuestion = 0;
    state.answers = [];
    state.totalPoints = 0;
    state.topSymptoms = [];
    transitionTo(renderStart);
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  transitionTo(renderStart);

})();
